export default class TrainingProgramSuggestion{
    requiredProfession;
    programDescription;
    name;
    phoneNumber;
    studySpecialty;
}